// extracted by mini-css-extract-plugin
module.exports = {"toast":"_3pvwYIJVSmb2iQAe3k12we"};